import apiClient from '../api/apiClient';

export interface FcmsFeatureLimits {
  tier: 'admin' | 'basic' | 'pro' | 'unlimited';
  planId: string | null;
  features: {
    watchlists: { limit: number | null; current: number; canAdd: boolean };
    assets: { limit: number | null; current: number; canAdd: boolean };
    youtubeChannels: { limit: number | null; current: number; canAdd: boolean };
    chartLayouts: { limit: number | null; current: number; canAdd: boolean };
    priceAlerts: boolean;
    insiderTransactions: boolean;
    newsSentiment: boolean;
    earningsTranscripts: boolean;
    institutionalHoldings: boolean;
    signalBar: boolean;
    communityHeatmap: boolean;
  };
  hasFcmsSubscription: boolean;
}

class FcmsLimitsService {
  async getLimits(): Promise<FcmsFeatureLimits> {
    const response = await apiClient.get('/fcms/assets/limits');
    return response.data;
  }
}

export default new FcmsLimitsService();
